import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const List = ({ title, data, tone }) => (
  <div className={`rounded-xl p-3 text-xs ${tone}`}>
    <p className="mb-1 font-bold">{title}</p>
    {Object.entries(data).filter(([, n]) => n > 0).map(([k, n]) => <p key={k} className="flex justify-between"><span>{k.replaceAll("_", " ")}</span><b>{n}</b></p>)}
  </div>
);

export const DemoPurgeCard = () => {
  const [s, setS] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/demo-data").then((r) => setS(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!s) return null;
  const purge = async () => {
    setBusy(true);
    try {
      await api.post("/admin/demo-data/purge", { confirm: text });
      toast.success("Dati demo eliminati. Backup preliminare creato.");
      setTimeout(() => window.location.reload(), 800);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <section className="card-soft mb-5 border-l-4 border-l-amber-500 p-5" data-testid="demo-purge-card">
      <h3 className="flex items-center gap-2 font-bold"><Eraser className="h-4 w-4 text-amber-600" />Avvio con dati reali</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        {s.present ? "L'app contiene ancora dati dimostrativi. Eliminali per partire da zero: prima viene creato automaticamente un backup cifrato." : "Nessun dato demo presente: l'app è pronta per i dati reali."}
      </p>
      <div className="mt-3 grid gap-3 md:grid-cols-2">
        <List title="Verrà eliminato" data={s.delete} tone="bg-red-50" />
        <List title="Resta" data={s.keep} tone="bg-emerald-50" />
      </div>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder={`Scrivi: ${s.confirm_text}`} className="rounded-xl" data-testid="demo-purge-confirm" />
        <Button variant="destructive" onClick={purge} disabled={busy || text.trim().toUpperCase() !== s.confirm_text} className="rounded-xl" data-testid="demo-purge-button">Elimina dati demo</Button>
      </div>
    </section>
  );
};
